<template>
  <!-- <div id="app"> -->
  <v-app id="app">
    <component :is="layout">
      <router-view/>
    </component>
  </v-app>
  <!-- </div> -->
</template>
<script>
import VueAnalytics from 'vue-analytics'
import Vue from 'vue'
import router from './router'
const defaultLayout = 'default'

const isProd = process.env.NODE_ENV === 'production'

if (isProd) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GA_ID,
    router,
    debug: {
      enabled: false, // No debug in prod
      sendHitTask: true // Send hits in prod
    }
  })
}

export default {
  computed: {
    layout () {
      var layout = (typeof this.$route.meta.layout !== 'undefined') ? this.$route.meta.layout : defaultLayout
      return layout + '-layout'
    }
  }
}
</script>

<style lang="scss">
</style>
